module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ded#ded"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Part 1: "), _c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_vm._v("High Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("Tournament Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("Smithfield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("3. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lamastide")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("4. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Proud Cis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Halloween")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Part 2: "), _c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fools’ Season")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Night and Fogge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Somerset")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robin Hood Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Honour of Pontefract")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Part 3: "), _c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Paper Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wakefield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sherwood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine Ladies Dancing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridge on the Dove")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Devil’s Chair")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forge Books by R. Garcia y Robertson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/praise#pra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#cpt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0